"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var events_1 = require("events");
var get_win_1 = require("get-win");
var _a = get_win_1.get(), document = _a.document, navigator = _a.navigator;
var IncomingMessage = /** @class */ (function (_super) {
    tslib_1.__extends(IncomingMessage, _super);
    /**
     * @description
     * Emulates nodes IncomingMessage in the browser.
     * See: https://nodejs.org/api/http.html#http_class_http_incomingmessage
     *
     * @param socket A mock net.Socket object.
     */
    function IncomingMessage(socket) {
        var _this = _super.call(this) || this;
        _this.socket = socket;
        _this.connection = _this.socket;
        _this.httpVersionMajor = 1;
        _this.httpVersionMinor = 1;
        _this.httpVersion = "1.1";
        _this.complete = false;
        _this.method = "GET";
        _this.url = "";
        return _this;
    }
    return IncomingMessage;
}(events_1.EventEmitter));
exports.IncomingMessage = IncomingMessage;
/**
 * @description
 * Creates a new incoming request and sets up some headers and other properties.
 *
 * @param server The @rill/http server to create the IncomingMessage for.
 * @param options Fetch style options to create the request.
 * @internal
 */
function _createIncomingMessage(server, options) {
    var headers = options.headers;
    var parsed = options.parsed;
    var incomingMessage = new IncomingMessage({
        encrypted: parsed.protocol === "https:",
        remoteAddress: "127.0.0.1",
        server: server
    });
    // Set default headers.
    var referrer = headers && (headers.referrer || headers.referer);
    incomingMessage.headers = tslib_1.__assign({ accept: "*/*", "accept-language": navigator.language, "cache-control": "max-age=0", connection: "keep-alive", cookie: document.cookie, date: new Date().toUTCString(), host: parsed.host, referer: referrer, referrer: referrer, "user-agent": navigator.userAgent }, normalizeHeaders(headers));
    // Setup other properties.
    incomingMessage.method = options.method
        ? options.method.toUpperCase()
        : "GET";
    incomingMessage._options = options;
    return incomingMessage;
}
exports._createIncomingMessage = _createIncomingMessage;
/**
 * @description
 * Converts a headers object to a regular object.
 *
 * @param headers A headers object to normalize to a regular object.
 * @internal
 */
function normalizeHeaders(headers) {
    if (headers == null || typeof headers.forEach !== "function") {
        return headers;
    }
    var result = {};
    headers.forEach(function (value, header) {
        result[header] = value;
    });
    return result;
}
//# sourceMappingURL=incoming-message.js.map